import React from "react";

const Logo = (props) => {
  return (
    <img
      src=".\logo\AIC logo.png"
      width={"100%"}
      alt="Logo"
      {...props}
    />
  );
};

export default Logo;
